exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1F4Doh_0G24Io3{background-color:#fdfae5;background-image:linear-gradient(to bottom right,rgba(0,0,0,.05) 25%,transparent 0,transparent 50%,rgba(0,0,0,.05) 0,rgba(0,0,0,.05) 75%,transparent 0,transparent);background-size:14px 14px;min-height:30px;padding:12px 12px 12px 50px;position:relative}._1F4Doh_0G24Io3 ._1xtsOrw05K5iny{position:absolute;top:12px;left:12px}._1F4Doh_0G24Io3 .cOopJ-zHKCqUI4{font-size:16px;line-height:30px;margin:0}", ""]);

// exports
exports.locals = {
	"archivedBanner": "_1F4Doh_0G24Io3",
	"archiveBannerIcon": "_1xtsOrw05K5iny",
	"archivedBannerText": "cOopJ-zHKCqUI4"
};